<template>
    <thead>
        <slot name="additionalHead"></slot>
        <tr>
            <th v-if="hasCheckbox">
                <Checkbox
                    :modelValue="selectedAll"
                    @update:modelValue="(newValue) => $emit('update:selected-all', newValue)"
                />
            </th>
            <th
                v-for="(column, index) in columns"
                :key="index"
                @drop="onDrop($event, index)"
                @dragover.prevent
                @dragenter.prevent
                :style="[column.type === 'number' ? 'text-align: end;' : 'text-align: start;']"
            >
                <div :class="[
                    column.type === 'number' ? 'thead-th-content-right' : 'thead-th-content-left',
                    'thead-th-content',
                    getColumnOrder(column.name, column.orderable) !== null ? 'active' : '',
                    column.orderable === true ? 'orderable' : ''
                ]" :draggable="!isStatic" @dragstart="startDrag($event, index)">
                    <div class="position" :class="[column.type === 'number' ? 'position-right' : 'position-left']" v-if="column.type !== 'number'">
                        <i class="icon-move-alt1"></i>
                    </div>
                    <div :class="[column.type === 'number' ? 'main-right' : 'main-left', 'main']" @click="setColumnOrder(column.name, column.orderable)">
                        <div class="position-right" v-if="column.type === 'number'">
                            <i class="icon-move-alt1"></i>
                        </div>
                        <div class="title">{{ translate(column.title) }}</div>
                        <div class="order" v-if="column.orderable && column.type !== 'number'">
                            <i v-if="getColumnOrder(column.name) === null" class="icon-arrow-down8" style="color: #dfdfdf;"></i>
                            <i v-else-if="getColumnOrder(column.name) === 'desc'" class="icon-arrow-down8"></i>
                            <i v-else-if="getColumnOrder(column.name) === 'asc'" class="icon-arrow-up8"></i>
                        </div>
                    </div>
                    <div class="order-right" v-if="column.orderable && column.type === 'number'">
                        <i v-if="getColumnOrder(column.name) === null" class="icon-arrow-down8" style="color: #dfdfdf;"></i>
                        <i v-else-if="getColumnOrder(column.name) === 'desc'" class="icon-arrow-down8"></i>
                        <i v-else-if="getColumnOrder(column.name) === 'asc'" class="icon-arrow-up8"></i>
                    </div>
                </div>
            </th>
            <th v-if="!config.settings.isStatic" style="width: 40px;">
                <div class="thead-columns d-flex justify-content-center">
                    <Select ref="componentToClick"
                        :options="lists.columns"
                        icon="icon-equalizer2"
                        :title-can-change="false"
                        :is-multi="true"
                        :has-search="true"
                        :modelValue="selectedColumnNames"
                        @update:modelValue="changeColumns"
                    />
                </div>
            </th>
        </tr>
    </thead>
</template>

<script>
import Checkbox from "../../new/form/checkbox/AppCheckbox.vue";
import Select from "./filters/SelectComponent.vue";

export default {
    name: "HeadComponent",
    components: {Select, Checkbox},
    emits: ['update:columns', 'update:orders', 'update:selected-all', 'action:reload'],
    props: ['config', 'columns', 'orders', 'selectedAll', 'isStatic', 'hasCheckbox'],
    data() {
        return {
            lists: {
                columns: this.config.columns.map(filter => ({key: filter.name, value: translate(filter.title), disabled: filter.required})),
            },
            customColumns: []
        }
    },
    methods: {
        getColumnOrder(columnName, orderable) {
            if (orderable === false) {
                return null
            }

            let column = this.orders.find((order) => order.column === columnName);

            return column ? column.dir : null;
        },
        setColumnOrder(columnName, orderable) {
            if (!orderable) {
                return;
            }

            let newOrders = JSON.parse(JSON.stringify(this.orders)),
                columnOrdering = this.getColumnOrder(columnName);

            if (columnOrdering === 'desc') {
                newOrders = newOrders.map(function (order)
                {
                    if (order.column === columnName) {
                        order.dir = 'asc';
                    }

                    return order;
                })
            } else if (columnOrdering === 'asc') {
                newOrders = newOrders.filter((order) => order.column !== columnName);
            } else {
                newOrders.push({
                    column: columnName,
                    dir : 'desc'
                })
            }

            this.$emit('update:orders', newOrders)
        },
        startDrag(evt, columnIndex) {
            evt.dataTransfer.dropEffect = 'move'
            evt.dataTransfer.effectAllowed = 'move'
            evt.dataTransfer.setData('dragIndex', columnIndex)
        },
        onDrop(evt, dropIndex) {
            let newColumns = [],
                dragIndex = parseInt(evt.dataTransfer.getData('dragIndex'));

            if (dropIndex === dragIndex) {
                return;
            }

            for (let i = 0; i < this.columns.length; i++) {
                if (i === dragIndex) {
                    continue;
                }

                if (i === dropIndex) {
                    if (dropIndex > dragIndex) {
                        newColumns.push(this.columns[i])
                        newColumns.push(this.columns[dragIndex])
                    } else {
                        newColumns.push(this.columns[dragIndex])
                        newColumns.push(this.columns[i])
                    }

                    continue;
                }

                newColumns.push(this.columns[i])
            }

            this.$emit('update:columns', newColumns)
        },
        changeColumns(newValue, withReload = true) {
            let allColumns = [...this.config.columns, ...this.customColumns],
                allColumnsGroupByName = allColumns.reduce((object, item) => (object[item.name] = item, object), {}),
                newColumns = [];
            newValue.map(columnName => {
                if (allColumnsGroupByName[columnName]) {
                    newColumns.push(allColumnsGroupByName[columnName])
                }
            })
            this.$emit('update:columns', newColumns)

            if (withReload) {
                this.$emit('action:reload')
            }
        },
        setCustomColumns(data) {
            let filteredTemplates = data.templates.filter((template) => (template.uuid === this.config.templateUuid))

            if (this.config.settings.hasCustomColumns) {
                this.customColumns = data.custom_fields.map((customColumn) => (
                    {orderable: 1, searchable: 1, title: customColumn.title, additional: [], name: this.getColumnName(customColumn), type: customColumn.type}
                ));

                let customColumnsList = this.customColumns.map(filter => ({key: filter.name, value: filter.title}));

                this.lists.columns = [...this.lists.columns, ...customColumnsList]
            }

            if (filteredTemplates.length > 0 && this.config.templateUuid != null) {
                let template = filteredTemplates[0];

                this.changeColumns(template.cache.columns, false)
            } else {
                this.changeColumns(this.config.columns.filter(column => column.default).map(column => column.name), false)
            }
        },
        getColumnName(customField)
        {
            let name = '';

            return name + customField.uuid
        }
    },
    computed: {
        selectedColumnNames() {
            return this.columns.map(column => column.name);
        },
    },
    watch: {
        'config.columns': {
            handler: function(val) {
                this.lists.columns = val.map(filter => ({key: filter.name, value: translate(filter.title), disabled: filter.required}))
            },
            deep: true
        }
    }
}
</script>
<style>
.thead-columns > .datatable-dropdown > .datatable-button > .icon-table2 {
    font-size: 14px;
}
.thead-columns > .datatable-dropdown > .datatable-dropdown-menu {
    top: 45px;
    right: 0;
}
</style>
<style scoped>
.thead-columns {
    background: white;
}
.thead-th-content-left {
    display: inline-flex;
    position: relative;
    left: -10px;
    border-radius: 2px;
    -ms-user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    white-space: nowrap;
}
.thead-th-content-right {
    display: inline-flex;
    position: relative;
    right: 0px;
    border-radius: 2px;
    -ms-user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    white-space: nowrap;
}

.thead-th-content i {
    font-size: 12px;
    line-height: 14px;
}


.thead-th-content > div{
    float: left;
    padding: 5px 0;
}

.thead-th-content-left > .main-left > div {
    float: left;
}
.thead-th-content-right > .main-right > div {
    float: right;
    padding: 5px 0px 5px 10px;
}

.thead-th-content > .position-left {
    opacity: 0;
    background: #eaeaea;
    padding: 5px 2px;
    cursor: grab;
    border-top-left-radius: 2px;
    border-bottom-left-radius: 2px;
    transition: opacity 0.3s;
}
.thead-th-content > .main > .position-right {
    opacity: 0;
    background: #eaeaea;
    padding: 5px 2px;
    cursor: grab;
    border-top-right-radius: 2px;
    border-bottom-right-radius: 2px;
    transition: opacity 0.3s;
}

.thead-th-content:hover > .position {
    opacity: 1;
}
.thead-th-content:hover > .main > .position-right {
    opacity: 1;
}

.thead-th-content > .main-left{
    cursor: pointer;
    padding: 5px 10px;
    position: relative;
    left: -16px;
    transition: left 0.3s, padding-left 0.3s;
    display: flex;
}
.thead-th-content > .main-right{
    cursor: pointer;
    padding: 0px;
    position: relative;
    right: -34px;
    transition: right 0.4s, padding-rigth 0.3s;
    display: flex;
}

.thead-th-content:hover > .main-left{
    left: 0;
}
.thead-th-content:hover > .main-right{
    right: 0;
    padding: 0px;
}
.thead-th-content:hover > .main, .thead-th-content.active .main{
    background: #f4f4f4;
    right: 0px
}

.thead-th-content > .main > .order {
    margin-left: 10px;
    opacity: 0;
    transition: opacity 0.3s;
}
.thead-th-content > .order-right {
    opacity: 0;
    background: #f4f4f4;
    padding: 5px 10px;
    transition: opacity 0.3s;
}
.thead-th-content:hover > .order-right {
    opacity: 1;
}
.thead-th-content.active > .order-right {
    opacity: 1;
}


.thead-th-content:hover > .main > .order {
    opacity: 1;
}

.thead-th-content.active > .main > .order {
    opacity: 1;
}
</style>
